package screens

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 16.09.22
 * Author : marcusspors
 */

sealed class EScreens(val mPath: String, val mRoute: String) {

    object HOME_SCREEN : EScreens("/", "/")
    object COLOUR_FINDER_UPLOAD_SCREEN : EScreens("/colourFinderUpload", "/colourFinderUpload")
    class COLOUR_FINDER_MODULE_SCREEN(mToken: String?) :
        EScreens("/colourFinderModule/${mToken}", "/colourFinderModule/:token")

    object COLOUR_TONE_LIST_SCREEN : EScreens("/colourToneListScreen", "/colourToneListScreen")
    object WATCH_LIST_SCREEN : EScreens("/watchList", "/watchList")
    object COLOUR_TONE_DETAIL : EScreens("/colourTone", "/colourTone")
    object COLOUR_PRODUCT_DETAIL_SCREEN : EScreens("/colourProduct", "/colourProduct")
    object PRODUCT_LIST_SCREEN : EScreens("/productList", "/productList")
    object WALL_COLOURER_UPLOAD_SCREEN : EScreens("/wallColourerUpload", "/wallColourerUpload")
    class WALL_COLOURER_MODULE_SCREEN(mType: EColoursOnWallType? = EColoursOnWallType.TOKEN, mToken: String?) :
        EScreens(
            "/wallColourerModule/${(mType ?: EColoursOnWallType.TOKEN).name}/$mToken",
            "/wallColourerModule/:type/:token"
        )

    object IMPRINT_SCREEN : EScreens("/imprint", "/imprint")

    object INTEGRITY_SCREEN : EScreens("/integrity", "/integrity")
    object PRIVACY_SCREEN : EScreens("/privacy", "privacy")
    object GALLERY_SCREEN : EScreens("/gallery", "/gallery")
    object SELECTABLE_WATCH_LIST_SCREEN : EScreens("/selectableWatchList", "/selectableWatchList")

    object SETTINGS_SCREEN : EScreens("/settings", "/settings")
    fun getPath(): String {
        return mPath
    }

    fun getRoute(): String {
        return mRoute
    }

    enum class EColoursOnWallType {
        TOKEN,
        SCENE
    }


}
